'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002422 from "./presto.-Agent-View$$anon$22.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024proto$0024$002dFile$002dContent$0024 from "./presto.types$proto$-File-Content$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$21() {
  this.axv = null;
  this.axn = null;
  this.axo = false;
  this.axw = null;
  this.axx = false;
  this.axA = null;
  this.axt = null;
  this.axu = false;
  this.axp = null;
  this.axq = false;
  this.axr = null;
  this.axs = false;
  this.axy = false;
  this.axz = false;
  this.axv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axA = "FileContent";
}
export { $c_Lpresto_AgentView$$anon$21 as $c_Lpresto_AgentView$$anon$21 };
$p = $c_Lpresto_AgentView$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$21;
/** @constructor */
function $h_Lpresto_AgentView$$anon$21() {
}
export { $h_Lpresto_AgentView$$anon$21 as $h_Lpresto_AgentView$$anon$21 };
$h_Lpresto_AgentView$$anon$21.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.axv;
});
$p.L = (function() {
  if ((!this.axo)) {
    this.axn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axo = true;
  }
  return this.axn;
});
$p.O = (function() {
  if ((!this.axx)) {
    this.axw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axx = true;
  }
  return this.axw;
});
$p.E = (function() {
  return this.axA;
});
$p.t = (function() {
  if ((!this.axu)) {
    this.axt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("content", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.axu = true;
  }
  return this.axt;
});
$p.M = (function() {
  if ((!this.axq)) {
    this.axp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().r2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.axq = true;
  }
  return this.axp;
});
$p.Q = (function() {
  if ((!this.axs)) {
    this.axr = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002422.$c_Lpresto_AgentView$$anon$22();
    this.axs = true;
  }
  return this.axr;
});
$p.w = (function() {
  if ((!this.axz)) {
    this.axy = false;
    this.axz = true;
  }
  return this.axy;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee149) => ((p) => \u03b4scrutinee149.cGK(p)))($j_presto$002etypes$0024proto$0024$002dFile$002dContent$0024.$m_Lpresto_types$proto$FileContent$())));
});
var $d_Lpresto_AgentView$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$21, "presto.AgentView$$anon$21", ({
  DK: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$21 as $d_Lpresto_AgentView$$anon$21 };
//# sourceMappingURL=presto.-Agent-View$$anon$21.js.map
